import { IPaymentsAndDeductions } from 'API/paymentAndDeductions';
import {
  BENEFITS_GROUP_STATUS,
  PAYMENT_DEDUCTION_STATUS,
} from 'Enum/paymentsDeduction';
import { CircularArrows, MinusInsideCircle, PlusInsideCircle } from 'Images';

export function getPaymentDeductionGroupStatus(
  statusCode: number,
  dictionary: any
) {
  switch (statusCode) {
    case BENEFITS_GROUP_STATUS.AUTOMATIC: {
      return {
        text: dictionary.payment,
        image: PlusInsideCircle,
      };
    }
    case BENEFITS_GROUP_STATUS.PROACTIVE: {
      return {
        text: dictionary.refund,
        image: CircularArrows,
      };
    }
    case BENEFITS_GROUP_STATUS.DEDUCTION: {
      return {
        text: dictionary.deduction,
        image: MinusInsideCircle,
      };
    }
    default: {
      return {
        text: '',
        image: '',
      };
    }
  }
}

export function getPaymentDeductionStatus(statusCode: number, dictionary: any) {
  switch (statusCode) {
    case PAYMENT_DEDUCTION_STATUS.OPENED_IN_SYSTEM:
      return {
        text: dictionary.opened,
        style: {
          background: 'primary.shade_50',
          border: '1px solid',
          borderColor: 'primary.shade_200',
        },
      };
    case PAYMENT_DEDUCTION_STATUS.UNDER_REVIEW:
      return {
        text: dictionary.review,
        style: {
          background: '#FFFCF8',
          border: '1px solid #FFEDCE',
        },
      };
    case PAYMENT_DEDUCTION_STATUS.APPROVED:
      return {
        text: dictionary.done,
        style: {
          background: '#EAF7F3',
          border: '1px solid #A2DDCD',
        },
      };
    default:
      return {
        text: '',
        style: {},
      };
  }
}

export function getPaymentDeductionType(
  paymentDeductionItem: IPaymentsAndDeductions,
  dedactionType: any,
  isDatesSameMonth?: boolean
) {
  if (
    paymentDeductionItem.payStartDate &&
    paymentDeductionItem.payEndDate &&
    !isDatesSameMonth
  ) {
    return dedactionType.installmentsPlan;
  } else if (paymentDeductionItem.payStartDate) {
    const startDate = new Date(paymentDeductionItem.payStartDate);
    if (startDate.getFullYear() === 2999) {
      return dedactionType.permanent;
    } else {
      return dedactionType.once;
    }
  }
  return null;
}
